//用户列表的功能
import request from './request'

//单个用户的购买记录
export function _userOrderBuy(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/order/index',
  })
  return request(config)
}

//单个用户的购买记录订单详情
export function _orderSingleInfo(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/order/getinfo',
  })
  return request(config)
}

// 单个课程的打赏信息
export function _rewardSingleInfo(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/order/course-reward',
  })
  return request(config)
}

//退款
export function _orderRrfund(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/order/refund',
  })
  return request(config)
}

//支付给讲师
export function _payToTeacher(data = {}) {
  const config = Object.assign(data, {
    method: 'get',
    url: '/admin/order/pay-teacher',
  })
  return request(config)
}


